import { createAction } from 'redux-actions';
import { change as reduxChange } from 'redux-form';

import moment from "moment";

import { bookingFormInitialValues } from './reducers';
import {
	fetchReservationData as apiFetchReservationData,
	fetchRoomTypesAvailabilitiesData as apiFetchRoomTypesAvailabilitiesData,
	fetchAresData as apiFetchAresData,
	submitReservation as apiSubmitReservation,
	fetchInitData as apiFetchInitData,
	fetchImage as apiFetchImage,
	fetchDiscountCode as apiFetchDiscountCode,
} from '../api';
import {
	getDefaultBoardBase,
	getDefaultBoardBases,
	processRoomTypes,
} from '../apiHelpers';
import { DATE_FORMAT } from "../constants";
import { getCountryValue } from '../enums/countries';
import { injectStyleEl } from '../dom';
import { getGoogleOffer, getOfferContext } from '../structuredData';

export const SET_INITIATED = 'SET_INITIATED';
export const setInitiated = createAction(SET_INITIATED);

export const SET_STEP = 'SET_STEP';
export const setStep = createAction(SET_STEP);

export const SET_MAX_STEP = 'SET_MAX_STEP';
export const setMaxStep = createAction(SET_MAX_STEP);

export const SET_LOADING = 'SET_LOADING';
export const setLoading = createAction(SET_LOADING);

export const SET_CAN_CONTINUE = 'SET_CAN_CONTINUE';
export const setCanContinue = createAction(SET_CAN_CONTINUE);

export const SET_ROOM_OFFERS = 'SET_ROOM_OFFERS';
export const setRoomOffers = createAction(SET_ROOM_OFFERS);

export const SET_STORNO_INSURANCE_PRICE = 'SET_STORNO_INSURANCE_PRICE';
export const setStornoInsurancePrice = createAction(SET_STORNO_INSURANCE_PRICE);

export const SET_TOTAL_PRICE = 'SET_TOTAL_PRICE';
export const setTotalPrice = createAction(SET_TOTAL_PRICE);

export const SET_PRICE_TO_PAY = 'SET_PRICE_TO_PAY';
export const setPriceToPay = createAction(SET_PRICE_TO_PAY);

export const SET_API_ROOMS_RESPONSE = 'SET_API_ROOMS_RESPONSE';
export const setApiRoomsResponse = createAction(SET_API_ROOMS_RESPONSE);

export const SET_API_ROOM_TYPES_AVAILABILITIES_RESPONSE = 'SET_API_ROOM_TYPES_AVAILABILITIES_RESPONSE';
export const setApiRoomTypesAvailabilitiesResponse = createAction(SET_API_ROOM_TYPES_AVAILABILITIES_RESPONSE);

export const SET_API_DATA_RESPONSE = 'SET_API_DATA_RESPONSE';
export const setApiDataResponse = createAction(SET_API_DATA_RESPONSE);

export const SET_API_DISCOUNT_CODE_RESPONSE = 'SET_API_DISCOUNT_CODE_RESPONSE';
export const setApiDiscountCodeResponse = createAction(SET_API_DISCOUNT_CODE_RESPONSE);

export const SET_DISCOUNT_CODE_AUTO_REMOVED = 'SET_DISCOUNT_CODE_AUTO_REMOVED';
export const setDiscountCodeAutoRemoved = createAction(SET_DISCOUNT_CODE_AUTO_REMOVED);

export const SET_SELECTED_ROOM_TYPE = 'SET_SELECTED_ROOM_TYPE';
export const setSelectedRoomType = createAction(SET_SELECTED_ROOM_TYPE);

export const SET_RESERVATION_STATUS = 'SET_RESERVATION_STATUS';
export const setReservationStatus = createAction(SET_RESERVATION_STATUS);

export const SET_TOTAL_NO_OF_GUESTS = 'SET_TOTAL_NO_OF_GUESTS';
export const setTotalNoOfGuests = createAction(SET_TOTAL_NO_OF_GUESTS);

export const SET_NO_OF_NIGHTS = 'SET_NO_OF_NIGHTS';
export const setNoOfNights = createAction(SET_NO_OF_NIGHTS);

export const SET_LANG = 'SET_LANG';
export const setLang = createAction(SET_LANG);

export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';
export const setTranslations = createAction(SET_TRANSLATIONS);

export const SET_GOOGLE_SOLD_OUT = 'SET_GOOGLE_SOLD_OUT';
export const setGoogleSoldOut = createAction(SET_GOOGLE_SOLD_OUT);

export function fetchInitData() {
	return async (dispatch, getState) => {
		try {
			const response = await apiFetchInitData(getState());

			// Vlozime styly
			injectStyleEl(response.css);

			// Nastavit hodnoty do storu
			dispatch(setApiDataResponse(response));

			if (response.package) {
				// Pobyt termínu nastavený balíčkem
				bookingFormInitialValues.arrival = moment(response.package.arrival, 'YYYY-MM-DD').format(DATE_FORMAT);
				bookingFormInitialValues.departure = moment(response.package.departure, 'YYYY-MM-DD').format(DATE_FORMAT);

			} else if (getState().app.source !== 'google') {
				// Termín od Googlu se nepřepisuje, jinak by Google hlásil "Wrong itinerary"
				// Posuneme výchozí datum příjezdu a odjezdu dle nastavení času poslední rezervace a min. délky pobytu
				let arrival = 0;
				let departure = 1;
				if (response.closingDay !== 0) {
					arrival -= response.closingDay;
					departure -= response.closingDay;
				}
				if (response.closingTime !== null) {
					let closingTime = response.closingTime.split(':');
					if (closingTime.length === 2) {
						closingTime = parseInt(closingTime[0], 10) * 60 + parseInt(closingTime[1], 10); // počet minut od začátku dne
						let now = new Date();
						let currentTime = now.getHours() * 60 + now.getMinutes(); // počet minut od začátku dne
						if (currentTime > closingTime) {
							arrival++;
							departure++;
						}
					}
				}
				if (response.lengthOfStay[0] > 1) {
					departure += response.lengthOfStay[0] - 1;
				}
				if (arrival !== 0) {
					bookingFormInitialValues.arrival = moment().add(arrival, 'days').format(DATE_FORMAT);
				}
				if (departure !== 1) {
					bookingFormInitialValues.departure = moment().add(departure, 'days').format(DATE_FORMAT);
				}
			}

			return response;

		} catch(e) {
			throw(e);
		}
	}
}

export function fetchRoomTypesAvailabilitiesData(from, to) {
	return async (dispatch, getState) => {
		dispatch(setLoading(true));

		const t = performance.now();

		const response = await apiFetchRoomTypesAvailabilitiesData(getState(), from, to);

		if (getState().app.initiated) {
			const elapsed = performance.now() - t;
			if (elapsed < 1000) {
				// necháme animaci zobrazenou alespoň 1 vteřinu
				await new Promise(resolve => setTimeout(resolve, 1000 - elapsed));
			}
		}

		dispatch(setApiRoomTypesAvailabilitiesResponse(response));

		dispatch(setLoading(false));

		return response;
	}
}

export function fetchReservationData(arrival = null, departure = null) {
	return async (dispatch, getState) => {
		dispatch(setLoading(true));

		const t = performance.now();

		const response = await apiFetchReservationData(getState(), arrival, departure);
		const state = getState();

		if (state.app.initiated) {
			const elapsed = performance.now() - t;
			if (elapsed < 1000) {
				// necháme animaci zobrazenou alespoň 1 vteřinu
				await new Promise(resolve => setTimeout(resolve, 1000 - elapsed));
			}
		}

		if (!response || (Array.isArray(response) && !response.length)) {
			throw(Error('Server vrátil prázdnou odpověď.'));
		}

		// Uložit celý payload
		dispatch(setApiRoomsResponse(response));

		// Zpracovat pokoje pro vykreslení
		dispatch(setRoomOffers(processRoomTypes(response)));

		// Nastavit výchozí stravu
		dispatch(reduxChange('bookingForm', 'boardBase',
			state.app.boardBaseByGuestType
				? getDefaultBoardBases(state.app.boardBases, state.app.guestTypes, state.form.bookingForm.values.rooms)
				: getDefaultBoardBase(state.app.boardBases)
		));

		// Vyresetovat omezení stravy (sandamiano) - opětovně se přednastaví per host při vykreslení DietRestrictions
		dispatch(reduxChange('bookingForm', 'dietRestriction', []));

		// Vyresetovat vybrané pokoje
		dispatch(reduxChange('bookingForm', 'rooms', {}));

		// Termín od Googlu platí jen pro první načtení, po změně termínu už host vybírá sám
		if (state.app.source === 'google' && !state.app.initiated) {
			dispatch(preselectGoogleOffer());
		} else if (state.app.googleSoldOut) {
			dispatch(setGoogleSoldOut(false));
		}

		// Vyresetovat na první krok
		dispatch(setMaxStep(1));

		dispatch(setLoading(false));
		dispatch(setInitiated(true));

		return response;
	}
}

/**
 * Předvybere pokoj a stravu, na které host klikl v Googlu, aby se crawler Googlu dostal
 * k ceně jen klikáním. Když pokoj není volný, označí itinerář jako vyprodaný.
 */
function preselectGoogleOffer() {
	return (dispatch, getState) => {
		const state = getState();
		const googleOffer = getGoogleOffer(state.app.roomOffers, getOfferContext(state), state.app.room, state.app.ratePlan);

		if (googleOffer.soldOut) {
			dispatch(setGoogleSoldOut(true));
			return;
		}

		const { roomOffer, offer } = googleOffer;

		const guestTypes = {};
		Object.values(state.app.guestTypes).forEach(guestType => {
			guestTypes[guestType.id] = guestType.default ? offer.guests : 0;
		});

		dispatch(reduxChange('bookingForm', `rooms[${roomOffer.id}]`, [{ ...roomOffer, guestTypes }]));

		if (offer.boardBaseId && !state.app.boardBaseByGuestType) {
			dispatch(reduxChange('bookingForm', 'boardBase', state.app.boardBases[offer.boardBaseId].id));
		}
	};
}

export function fetchAresData() {
	return async (dispatch, getState) => {
		const response = await apiFetchAresData(getState());

		if (!response) {
			return false;
		}

		if (response.state !== 'OK') {
			return response.state;
		}

		dispatch(reduxChange('bookingForm', 'companyName', response.company));
		dispatch(reduxChange('bookingForm', 'companyDic', response.vatin));
		dispatch(reduxChange('bookingForm', 'companyStreet', response.address));
		dispatch(reduxChange('bookingForm', 'companyCity', response.city));
		dispatch(reduxChange('bookingForm', 'companyPostCode', response.zip));
		dispatch(reduxChange('bookingForm', 'companyCountry', getCountryValue(response.country)));

		return false;
	}
}

export function submitReservation(recaptchaToken) {
	return async (dispatch, getState) => {
		const response = await apiSubmitReservation(getState(), recaptchaToken);
		console.log(response);
		return response;
	}
}

export function fetchImage(url) {
	return async (dispatch, getState) => {
		const response = await apiFetchImage(getState(), url);
		console.log(response);
		return response;
	}
}

/**
 * @callback setArrivalCallback
 * @param {Object} state
 */

/**
 * Nastaví datum příjezdu.
 *
 * @param {moment.Moment} date
 * @param {?setArrivalCallback} callback
 */
export function setArrival(date, callback) {
	return async (dispatch, getState) => {
		dispatch({
			...reduxChange('bookingForm', 'arrival', date.format(DATE_FORMAT)),
			callback: () => {
				if (callback && typeof callback === 'function') {
					callback(getState());
				}
			}
		});
	}
}

export function fetchDiscountCode() {
	return async (dispatch, getState) => {
		dispatch(setLoading(true));

		const t = performance.now();

		const response = await apiFetchDiscountCode(getState());

		if (getState().app.initiated) {
			const elapsed = performance.now() - t;
			if (elapsed < 1000) {
				// necháme animaci zobrazenou alespoň 1 vteřinu
				await new Promise(resolve => setTimeout(resolve, 1000 - elapsed));
			}
		}

		dispatch(setApiDiscountCodeResponse(response));

		dispatch(setLoading(false));

		return response;
	}
}

export function clearDiscountCode() {
	return async (dispatch, getState) => {
		const response = undefined;

		dispatch(setApiDiscountCodeResponse(response));

		return response;
	}
}


// WEBPACK FOOTER //
// ./src/store/actions.js